var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatSetsUsApartLeftTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 436,
    viewBox: "0 0 319 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.562 349.797C323.018 358.971 317.595 376.198 303.769 377.727L-216.632 435.292C-228.12 436.563 -237.123 425.608 -233.653 414.584L-106.821 11.717C-103.351 0.692981 -89.6953 -3.12766 -81.0076 4.49458L312.562 349.797Z",
    fill: "url(#paint0_linear_304:2136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304:2136",
    x1: 339.848,
    y1: 373.737,
    x2: -340.265,
    y2: 159.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B7B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatSetsUsApartLeftTriangle);
export default __webpack_public_path__ + "static/media/what-sets-us-apart-left-triangle.8f7de3c0.svg";
export { ForwardRef as ReactComponent };